__turbopack_context__.v({
  "container": "ZDG9pG_container",
  "stuck": "ZDG9pG_stuck",
});
